module.exports = __webpack_public_path__ + "img/2024shnh-3.fd1d00dd.jpg";